import { Helmet } from "react-helmet-async";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
import { AboutUs, AppPromo } from "@/features/landing";
import { HeroPlanner, PlansSidebar } from "@/features/planner";

export const Route = createFileRoute("/")({
  component: Home,
});

function Home() {
  const [showPlans, setShowPlans] = useState(false);

  // close on ESC
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setShowPlans(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <main className="bg-white text-slate-900">
      <Helmet>
        <title>TravelHug | Your Intelligent Travel Companion</title>
      </Helmet>
      <Header onOpenPlans={() => setShowPlans(true)} />

      <HeroPlanner />
      <AboutUs />
      <AppPromo />
      <Footer />

      <PlansSidebar open={showPlans} onClose={() => setShowPlans(false)} />
    </main>
  );
}
